$(document).ready(function () {
    toastr.options.closeButton = true;
    toastr.options.progressBar = true;
    toastr.options.timeOut = 10000;
    toastr.options.extendedTimeOut = 10000;
})
